import React from 'react';
import { Divider, Drawer } from 'antd';
import Logo from '../../components/common/Logo';
import { observer } from 'mobx-react';
import { ArrowLeftOutlined, CloseOutlined } from '@ant-design/icons';
import UIStore from '@/stores/UIStore';
import PrivateMenu from 'layouts/menus/PrivateMenu';
import HeaderLinks from './HeaderLinks';
import UserStore from 'stores/UserStore';
import { useHistory } from 'react-router-dom';
import SearchBar from 'components/SearchBar';

export const MobileNav = () => {
    const history = useHistory();

    const onClose = () => {
        UIStore.onMobileNavToggle(false);
    };

    // UserStore.logout already shows the failure message.
    const handleLogout = () =>
        UserStore.logout()
            .then(() => history.push('/login/'))
            .catch(() => undefined);

    return (
        <Drawer
            placement="left"
            closable={false}
            onClose={onClose}
            open={UIStore.isMobileNavOpen}
            width={'360px'}
            bodyStyle={{ padding: 0 }}
        >
            <div className="d-flex flex-column h-100">
                <div className="d-flex align-items-center justify-content-between">
                    <div>
                        <Logo style={{ maxHeight: '40px', margin: '1rem auto' }} />
                    </div>
                    <div className="nav-close px-3" onClick={() => onClose()}>
                        <CloseOutlined />
                    </div>
                </div>
                <Divider className="mt-0" />
                <div className="d-flex flex-column-reverse px-3" style={{ rowGap: '0.5rem' }}>
                    {UserStore.isAuthenticated && UserStore.isVerified && UserStore.hasAContact ? (
                        <SearchBar className="w-100" />
                    ) : null}
                    <HeaderLinks />
                </div>

                {UserStore.isAuthenticated ? (
                    <div className="mobile-nav-menu">
                        <PrivateMenu isDrawer={true} onLogout={handleLogout} />
                    </div>
                ) : null}
            </div>
        </Drawer>
    );
};

export default observer(MobileNav);
